import { TunnelLayout } from "../../layouts/Tunnel/TunnelLayout";
import { AppDashboardProvider } from "../AppProvider/AppDashboardProvider/AppDashboardProvider";

import NotFoundPage from "./NotFound";
import { NotFoundPageProps } from "./types";

const NotFoundWithProviders: React.FC<NotFoundPageProps> = ({ deletedForm }) => {
  return (
    <AppDashboardProvider layout={TunnelLayout}>
      <NotFoundPage deletedForm={deletedForm} />
    </AppDashboardProvider>
  );
};

export default NotFoundWithProviders;
